// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"18721ac9","199":"18721ac9","476":"18721ac9","706":"18721ac9","987":"18721ac9"}[chunkId] + ".chunk.css";
};